export default "__VITE_ASSET__D2T2Mxoh__"